/**
 * Copyright (c) 2023, CYBRA Corp. All rights reserved.
 */
export class PropertyPatch {
  property: string;
  value: string;
}
